/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRegulationObligationsReviewSummaryQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationObligationReviewSummaryInput>;
}>;

export type IInternalRegulationObligationsReviewSummaryQuery = {
  __typename?: 'Query';
  internalRegulationObligationsReviewSummary: {
    __typename: 'InternalRegulationObligationsReviewSummary';
    totalObligationsCount: number;
    reviewedObligationsCount: number;
  };
};

export const InternalRegulationObligationsReviewSummaryDocument = gql`
  query InternalRegulationObligationsReviewSummary($input: InternalRegulationObligationReviewSummaryInput) {
    internalRegulationObligationsReviewSummary(input: $input) {
      __typename
      totalObligationsCount
      reviewedObligationsCount
    }
  }
`;

/**
 * __useInternalRegulationObligationsReviewSummaryQuery__
 *
 * To run a query within a React component, call `useInternalRegulationObligationsReviewSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRegulationObligationsReviewSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRegulationObligationsReviewSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalRegulationObligationsReviewSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IInternalRegulationObligationsReviewSummaryQuery,
    IInternalRegulationObligationsReviewSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IInternalRegulationObligationsReviewSummaryQuery,
    IInternalRegulationObligationsReviewSummaryQueryVariables
  >(InternalRegulationObligationsReviewSummaryDocument, options);
}
export function useInternalRegulationObligationsReviewSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IInternalRegulationObligationsReviewSummaryQuery,
    IInternalRegulationObligationsReviewSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IInternalRegulationObligationsReviewSummaryQuery,
    IInternalRegulationObligationsReviewSummaryQueryVariables
  >(InternalRegulationObligationsReviewSummaryDocument, options);
}
// @ts-ignore
export function useInternalRegulationObligationsReviewSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalRegulationObligationsReviewSummaryQuery,
    IInternalRegulationObligationsReviewSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationsReviewSummaryQuery,
  IInternalRegulationObligationsReviewSummaryQueryVariables
>;
export function useInternalRegulationObligationsReviewSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationsReviewSummaryQuery,
        IInternalRegulationObligationsReviewSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationsReviewSummaryQuery | undefined,
  IInternalRegulationObligationsReviewSummaryQueryVariables
>;
export function useInternalRegulationObligationsReviewSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationsReviewSummaryQuery,
        IInternalRegulationObligationsReviewSummaryQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IInternalRegulationObligationsReviewSummaryQuery,
    IInternalRegulationObligationsReviewSummaryQueryVariables
  >(InternalRegulationObligationsReviewSummaryDocument, options);
}
export type InternalRegulationObligationsReviewSummaryQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationsReviewSummaryQuery
>;
export type InternalRegulationObligationsReviewSummaryLazyQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationsReviewSummaryLazyQuery
>;
export type InternalRegulationObligationsReviewSummarySuspenseQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationsReviewSummarySuspenseQuery
>;
export type InternalRegulationObligationsReviewSummaryQueryResult = Apollo.QueryResult<
  IInternalRegulationObligationsReviewSummaryQuery,
  IInternalRegulationObligationsReviewSummaryQueryVariables
>;
